import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { LeaveRequestApplication } from "projects/models/src/public-api";
import { Observable } from "rxjs";
import { COMON_WEB_API } from "../tokens";

@Injectable({
  providedIn: 'root'
})
export class LeaveRequestService {

  constructor(@Inject(COMON_WEB_API) private apiUrl: string, private http: HttpClient) {}

  public createLeaveRequest(request: LeaveRequestApplication): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/leave-request`, request);
  }

}
